import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nss-camp',
  templateUrl: './nss-camp.component.html',
  styleUrls: ['./nss-camp.component.scss']
})
export class NssCampComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
